import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { Marquee } from "@/components/site/Marquee";
import { STEPS } from "@/data/content";
import { Video, Mic, Plug, Clock } from "lucide-react";

const SPECS = [
  { icon: Video, label: "Crisp, high-quality video", copy: "Sharp, cinematic footage — not grainy phone video." },
  { icon: Mic, label: "External microphone", copy: "Every word is clear, even in a loud room." },
  { icon: Plug, label: "One power outlet", copy: "That's all we need. No wifi required — it records locally." },
  { icon: Clock, label: "14-day delivery", copy: "Edited highlight video plus every raw clip." },
];

export default function HowItWorks() {
  return (
    <div className="pt-32">
      <section className="px-5 sm:px-8 pb-16">
        <div className="max-w-[1400px] mx-auto">
          <Reveal><p className="text-xs uppercase tracking-[0.3em] text-forest mb-6">How it works</p></Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-sans font-extrabold tracking-tight text-5xl sm:text-7xl leading-[1.02] max-w-4xl">
              Effortless for you. Unforgettable for them.
            </h1>
          </Reveal>
          <Reveal delay={0.2}><p className="text-ink/60 text-lg mt-6 max-w-2xl">You book. We handle everything else. Here's exactly what happens from the moment you reach out.</p></Reveal>
        </div>
      </section>

      <section className="px-5 sm:px-8 pb-24">
        <div className="max-w-[1400px] mx-auto">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-16 py-12 border-t border-clubborder items-start">
                <span className="font-serif text-[6rem] md:text-[9rem] leading-none text-forest/20">{s.n}</span>
                <div className="md:pt-6">
                  <h2 className="font-sans font-bold text-3xl sm:text-4xl mb-4">{s.title}</h2>
                  <p className="text-ink/60 text-lg max-w-2xl leading-relaxed">{s.copy}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <Marquee text="Book · We set up · You rewatch it" />

      <section className="px-5 sm:px-8 py-24 bg-clubmuted">
        <div className="max-w-[1400px] mx-auto">
          <Reveal><h2 className="font-sans font-extrabold tracking-tight text-4xl sm:text-5xl mb-14">The technical bits.</h2></Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {SPECS.map((s, i) => (
              <Reveal key={s.label} delay={i * 0.08}>
                <div className="bg-cream border border-clubborder rounded-2xl p-7 h-full">
                  <s.icon className="text-forest mb-5" size={28} />
                  <h3 className="font-sans font-bold text-lg mb-2">{s.label}</h3>
                  <p className="text-ink/60 text-sm leading-relaxed">{s.copy}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="px-5 sm:px-8 py-24 text-center">
        <Reveal>
          <p className="font-serif italic text-4xl sm:text-5xl text-forest mb-8 max-w-3xl mx-auto">Ready when you are.</p>
          <Link to="/book" data-testid="how-book-cta" className="inline-block rounded-full bg-forest text-cream px-10 py-4 text-base hover:bg-forest-deep transition-colors">Check Your Date</Link>
        </Reveal>
      </section>
    </div>
  );
}
